import { Wifi, WifiOff } from 'lucide-react'
import { useEffect, useState } from 'react'

export function ConnectionStatus({ isConnected }: { isConnected: boolean }) {
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (!isConnected) {
      setShow(true)
      const timer = setTimeout(() => setShow(false), 5000)
      return () => clearTimeout(timer)
    }
  }, [isConnected])

  if (!show) return null

  return (
    <div className="fixed right-4 bottom-4 z-50">
      <div
        className={`flex items-center gap-2 rounded-lg p-3 shadow-lg ${
          isConnected
            ? 'bg-green-100 text-green-800'
            : 'bg-yellow-100 text-yellow-800'
        }`}
      >
        {isConnected ? (
          <>
            <Wifi className="h-5 w-5" />
            <span>Conexão restabelecida</span>
          </>
        ) : (
          <>
            <WifiOff className="h-5 w-5" />
            <span>Tentando reconectar...</span>
          </>
        )}
      </div>
    </div>
  )
}
